import GlobalRequest from './global-request';

const URL = 'v2/template/formulas';

export default class FormulaApi {
    static async getAllFormulas(company_id) {
        return await GlobalRequest.getRequest(URL, {
            params: {
                company_id: company_id,
            },
        });
    }

    static async addFormula(body) {
        return await GlobalRequest.postRequest(URL, body);
    }

    static async updateFormula(formula_id, body) {
        return await GlobalRequest.patchRequest(`${URL}/${formula_id}`, body);
    }

    static async getFormulaById(formula_id, company_id) {
        return await GlobalRequest.getRequest(`${URL}/${formula_id}`, {
            params: {
                company_id,
            },
        });
    }

    static async deleteFormulaById(formula_id, company_id) {
        return await GlobalRequest.deleteRequest(`${URL}/${formula_id}`, {
            params: {
                company_id,
            },
        });
    }

    static async exportCompanyToShared(formula_id, company_id) {
        return await GlobalRequest.patchRequest(`${URL}/${formula_id}/export`, {
            params: {
                company_id,
            },
        });
    }

    static async importSharedToCompany(formula_id, company_id) {
        return await GlobalRequest.patchRequest(`${URL}/${formula_id}/import`, {
            params: {
                company_id,
            },
        });
    }

    static async testFormula(body) {
        return await GlobalRequest.postRequest(`${URL}/tester`, body);
    }
}
